import { Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { Navigate, Outlet } from 'react-router'

import {
  DashboardProvider,
  useDashboardContext,
} from './context/DashboardContext'

const DashboardsLayoutInner = () => {
  const { t } = useTranslation()
  const { pbxId, isAdmin, isLoading } = useDashboardContext()

  if (isLoading) {
    return (
      <Flex
        flexDirection="column"
        flex="1"
        alignSelf="stretch"
        overflow="hidden"
        justifyContent="center"
        alignItems="center"
      >
        <Text>{t('dashboards.gettingPbx')}</Text>
      </Flex>
    )
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />
  }

  if (!pbxId) {
    return (
      <Flex
        flexDirection="column"
        flex="1"
        alignSelf="stretch"
        overflow="hidden"
        justifyContent="center"
        alignItems="center"
      >
        <Text>{t('dashboards.gettingPbx')}</Text>
      </Flex>
    )
  }

  return (
    <Flex flexDirection="column" flex="1" alignSelf="stretch" overflow="hidden">
      <Outlet key={pbxId} />
    </Flex>
  )
}

export const DashboardsLayout = () => {
  return (
    <DashboardProvider>
      <DashboardsLayoutInner />
    </DashboardProvider>
  )
}
